import { ThreadsType } from './types'

const useApp = () => {
  const getInitialChatHistoryVisibility = (threads?: ThreadsType) => {
    if (threads) {
      const hasMoreThanOneThread = threads.length > 1
      const hasOnlyClosedThreads = threads.every(thread => !thread.isOpenThread)

      if (hasMoreThanOneThread || hasOnlyClosedThreads) {
        return true
      }
    }

    return false
  }

  return {
    getInitialChatHistoryVisibility
  }
}

export default useApp
